import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { MdLunchDining, MdOutlinePeopleOutline } from 'react-icons/md';
import { Button, ButtonGroup } from '@/shared/components/Button';
import { FiAlignRight } from 'react-icons/fi';
import { IoMdTime } from 'react-icons/io';
import { Badge } from '@mui/material';
import { Mealcontext } from '../../../../context/MealContext';
import { AuthContext } from '../../../../context/AuthContext';
import { GlobalContext } from '../../../../context/GlobalContext';
import { BookingContext } from '../../../../context/BookingContext';
import { PermissionContext } from '../../../../context/PermissionContext';



const MealCard = ({ 
  id, 
  mealname, 
  restaurantname,
  description,
  capacity, 
  type, 
  price,
  convertedprice,
  finalprice, 
  format, 
  image, 
  isVeg,
  mealOffereds,
  cuisine,
  locations,
}) => {
  const { permissionsAccess } = useContext(PermissionContext);
  const [mealOfferd, setMealOffered] = useState([]);
  const [modalShowBooking, setmodalShowBooking] = useState(false);
  const { 
    setRefresh, 
    setIsDetailsClick, 
    setRestaurantDetailsId,
   } = useContext(Mealcontext);
   const { agentId, currencyCode } = useContext(AuthContext);
   const { 
    showAddTripModal,
    setShowAddTripModal,
    paxs,
   setFormIndex,
   setStep1formData,
   setMealBookingData,
   } = useContext(BookingContext);
   const { apiGlobal } = useContext(GlobalContext);


  // useEffect(() => {
  //   if (showAddTripModal) {
  //     setmodalShowBooking(false); 
  //   }
  // }, [showAddTripModal]);

    let label;

  if (isVeg === '1') {
    label = <span className="bg-success text-white p-2" style={{ borderRadius: '50px' }}>VEG</span>;
  } else if (isVeg === '2') {
    label = <span className="bg-danger text-white p-2 w-50" style={{ borderRadius: '50px' }}>NON-VEG</span>;
  } else {
    label = <span className="bg-warning text-white p-2 w-50" style={{ borderRadius: '50px' }}>VEG/NON-VEG</span>;
  }



  useEffect(() => {
    if (mealOffereds) {
      const mealOffer = mealOffereds.split(','); 

      const mappedMeals = mealOffer.map((meal) => {
        switch (meal) {
          case '1':
            return 'Breakfast';
          case '2':
            return 'Snacks';
          case '3':
            return 'Lunch';
          case '4':
            return 'Dinner';
          default:
            return ''; 
        }
      });

      setMealOffered(mappedMeals); 
    }
  }, [mealOffereds]); 

  const logo = `${apiGlobal}/images/meal/${image}`;
  
  const MealDetails = () => {
    setIsDetailsClick(true);
    setRefresh(prev => !prev);
    setRestaurantDetailsId(id);
  };

  const hidetripmodalHandler = () => {
    setShowAddTripModal(false);
    setmodalShowBooking(true);
    setFormIndex(1);
  };

  // handle trip Add
//   const handletripAdd = async (values) => {
//     const utcStartDate = values.startDate;
//     const utcEndDate = values.endDate;

//        // Convert to IST
//        const startDate = new Date(utcStartDate);
//        const endDate = new Date(utcEndDate);
   
//        // IST offset is +5:30
//       const istOffset = 5.5 * 60 * 60 * 1000;
//       const startDateIST = new Date(startDate.getTime() + istOffset);
//       const endDateIST = new Date(endDate.getTime() + istOffset); 
      
//       // Format the dates (DD-MM-YYYY)
//       const formatDate = date => `${date.getFullYear()}-${String(date.getMonth() + 1)
//        .padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
   
   
//    const formattedStartDate = formatDate(startDateIST);
//    const formattedEndDate = formatDate(endDateIST);

//    const formattedValues = {
//     pax_details: paxs,
// };

// const formattedPaxDetails = JSON.stringify(formattedValues);


  

//     const formData = new FormData();
//     formData.append('agent_id', agentId);
//     formData.append('name', values.tripname);
//     formData.append('start_date', formattedStartDate);
//     formData.append('end_date', formattedEndDate);
//     formData.append('trip_type', values.triptype);
//     formData.append('trip_ref_no', values.ref_no);
//     formData.append('pax_details', formattedPaxDetails);
    
      
//   try {
//     // Send POST request with form data
//     const response = await fetch(`${apiGlobal}/agent/trip_add.php`, {
//       method: 'POST',
//       // headers: {
//       //   'Content-Type': 'application/json',
//       // },
//       body: formData, 
//     });
  
//     if (response.ok) {
//       const data = await response.json(); // Parsing the response JSON
//       if (data.status && data.message === 'Success') {
//         toast.success('Trip added successfully...');
//         hidetripmodalHandler();
//       }
//     } else {
//       // Handle non-200 responses
//       console.error('Error:', response.statusText);
//       toast.error('Something went wrong while adding paxs');
//     }
//   } catch (error) {
//     // Catch any network or other errors
//     console.error('Error during fetch:', error);
//   }
//   };

  const handlerShowBookModal = () => {
    setMealBookingData(prevState => ({
      ...prevState, // spread the previous state to retain other values
      showMealBookingModal: true, // set showMealBookingModal to true
      locations,
      mealOffereds,
      finalprice, 
      format, 
      id, 
      mealname, 
      restaurantname,
    }));
  };
  

  // const hideBookingModal = () => {
  //   setmodalShowBooking(false);
  //   setStep1formData({});
  //   setFormIndex(1);
  // };
 
 
  return (
    <div className="card mb-3 position-relative" style={{ maxWidth: '100%' }}>
      <div className="row">
        <div className="col-md-4 col-12">
          <img 
            src={logo} 
            alt={mealname} 
            style={{
              width: '100%',
              height: '200px',
              objectFit: 'cover',
              marginTop: '12px',
              marginBottom: '12px',
              borderRadius: '10px',
            }} 
          />
        </div>

        <div className="col-md-4 col-12">
          <div className="card-body">
            <h3 className="card-text" style={{ color: 'black' }}>
              {mealname} {restaurantname ? `/${restaurantname}` : ''}
            </h3>

            <p className="card-text"><FiAlignRight /> {description}</p>
            <p className="card-text">
              <IoMdTime /> Timing: {mealOfferd.join(',')}
            </p>
            <p className="card-text">
              Type: {(() => {
                switch (format) {
                  case '1': return 'FIT';
                  case '2': return 'GIT';
                  default: return 'Delhivery';
                }
              })()}
            </p>
            <p className="card-text">Format: {type}</p>
          </div>
        </div>

        <div className="col-md-4 col-12">
          <div className="card-body">
            {label}
            <p className="card-text mt-2"><MdLunchDining /> Cuisine: {cuisine}</p>
            <p className="card-text"><MdOutlinePeopleOutline /> Capacity: {capacity}</p>
          </div>
          <div className="card-body price d-flex align-items-center">
            {/* <h2 className="card-text me-2" style={{ color: 'red' }}>
              {price} <p className="d-inline" style={{ fontSize: '0.75em' }}>AED</p>
            </h2> */}
            <h2 className="card-text me-2" style={{ color: 'red' }}>
              {/* {finalprice} <p className="d-inline" style={{ fontSize: '0.75em' }}>{currencyCode}</p> */}
              {finalprice} <p className="d-inline" style={{ fontSize: '0.75em' }}>AED</p>
            
            </h2>

            <h5 style={{
              color: 'green',
            }}
            >(INR {convertedprice})
            </h5>

         
           
            {/* <h2 className="card-text me-2" style={{ color: 'blue' }}>
              {finalprice} <p className="d-inline" style={{ fontSize: '0.75em' }}>AED</p>
            </h2> */}
          </div>
          <ButtonGroup icons dir="ltr" className="mt-2 mx-2">
            {permissionsAccess?.[0]?.master_id === '1'
        && permissionsAccess?.[0]?.create === 1 && (
          <Button variant="outline-warning" size="sm" title="Booking" onClick={handlerShowBookModal}>
            Book
          </Button>
        )}
           
            <Button variant="outline-primary" title="Details" onClick={MealDetails}>
              <span className="lnr lnr-file-empty" /> Details
            </Button>
          </ButtonGroup>
        </div>
      </div>

      {/* Modal for Making Booking */}
      {/* <Modal
        show={modalShowBooking}
        onHide={hideBookingModal}
        ClassName="modal-90w"
        size="xl"
        // style={{ maxHeight: '80vh', height: 'auto' }} // Increase height
        aria-labelledby="example-custom-modal-styling-title"
        backdrop="static" // Prevent clicking outside the modal to close it
        keyboard={false} 
        
      >
        <Modal.Header closeButton>
          <Modal.Title>Make Booking</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <BookingForm 
            mealName={mealname}
            resName={restaurantname}
            price={finalprice}
            id={id}
            mealOffereds={mealOffereds}
            locations={locations}
            format={format}
            setmodalShowBooking={setmodalShowBooking} */}
      {/* /> */}
      {/* // <BookingForm 
          //   mealName={mealname}
          //   resName={restaurantname}
          //   price={finalprice}
          //   id={id}
          //   mealOffereds={mealOffereds}
          //   locations={locations}
          //   setmodalShowBooking={setmodalShowBooking}
          // /> */}
      {/* </Modal.Body>
      </Modal> */}
      

      {/* Modal for Add Trip */}
      {/* <Modal
        show={showAddTripModal}
        onHide={hidetripmodalHandler}
        centered
        size="xl"
        backdrop="static" // Prevent clicking outside the modal to close it
        keyboard={false} 
       
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Trip</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddTrip onSubmit={handletripAdd} />
        </Modal.Body>
      </Modal> */}
    </div>
  );
};

MealCard.propTypes = {
  id: PropTypes.string.isRequired,
  mealname: PropTypes.string.isRequired,
  restaurantname: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  convertedprice: PropTypes.string.isRequired,
  finalprice: PropTypes.string.isRequired,
  format: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  isVeg: PropTypes.string.isRequired,
  mealOffereds: PropTypes.string.isRequired,
  cuisine: PropTypes.string.isRequired,
  capacity: PropTypes.string.isRequired,
  locations: PropTypes.shape({
    id: PropTypes.string.isRequired,
    restaurant_name: PropTypes.string.isRequired,

  }).isRequired,
};

export default React.memo(MealCard);
